export const env = {
  STRIPE_PUBLISHABLE_KEY: "pk_live_0I7uVZYmtBOjJ6zFtSVE0sIr",
  MUUCHIT_UPLIFT_FEE_PERCENT: "15",
  MUUCHIT_ADMIN_EMAIL: "hello@muuchit.com",
  GOOGLE_MAPS_API_KEY: "AIzaSyCk4TQAtoZg9HFhMWmUykTyvHMvakkg2c4",
  RECAPTCHA_SITE_KEY: "6Lf7ZpoUAAAAAOlJ_fJB8um5di5jpn47sD0Sn8tZ",
  INITIAL_BOOKING_EXPIRATION_TIME_IN_MINUTES: "15",
  TWILIO_PHONE_MASK: "000-000-0000"
}
